import React, { useMemo } from "react";
import { PARTNER_LOGOS } from "../constants/partnersMarquee";
import "./TrustedBy.css";

function strHash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h;
}

function logosDisplayOrder(logos) {
  return [...logos].sort(
    (a, b) =>
      strHash(String(a)) - strHash(String(b)) || String(a).localeCompare(String(b)),
  );
}

function partnerLogoAlt(src) {
  const base = String(src).split("/").pop() || "partner";
  const name = base.replace(/\.[^/.]+$/, "").replace(/[-_]+/g, " ").trim();
  return name ? `${name} — partner of Panthi Events Ahmedabad` : "Partner logo";
}

const TrustedBy = () => {
  const orderedLogos = useMemo(() => logosDisplayOrder(PARTNER_LOGOS), []);

  return (
    <section id="trusted-by" className="trusted-by">
      <div className="trusted-by-container">
        <div className="section-header">
          <h2 className="section-title">Trusted By Major Brands</h2>
          <div className="title-underline"></div>
          <p className="trusted-by-subtitle">
            Proud to partner with leading organizations across industries
          </p>
        </div>

        <ul className="trusted-partners-grid" aria-label="Partner logos">
          {orderedLogos.map((src) => (
            <li key={src} className="trusted-partners-cell">
              <div className="trusted-partners-card">
                <img
                  src={src}
                  alt={partnerLogoAlt(src)}
                  className="trusted-partners-img"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TrustedBy;
